import React from 'react';
import cn from 'classnames';

import Icon from '../../Icon';
import { useTranslation } from 'client/hooks';
import css from './RequestPopUp.module.scss';

interface Props {
  className?: string;
  closePopUp: () => void;
}

const RequestPopUp: React.FC<Props> = (props) => {
  const { className, closePopUp } = props;
  const { translate } = useTranslation('popUps');

  const clickOnClose = () => {
    closePopUp();
  };

  return (
    <>
      <div className={cn(css.overlay, css[`${className}`])} onClick={clickOnClose}></div>
      <div className={cn(css.popUp, css[`${className}`])}>
        <div className={css.closeWrapper} onClick={clickOnClose}>
          <Icon type="close" />
        </div>
        <div className={css.icon}>
          <Icon type="red_hand" />
        </div>
        <div className={css.title}>{translate('listenerSpeakRequestsPopUp.title')}</div>
        {/* <div className={css.text}>{translate('listenerSpeakRequestsPopUp.text')}</div> */}
      </div>
    </>
  );
};

export default RequestPopUp;
